<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");

.nav-item .b-nav-dropdown .dropdown > a {
  color: white !important;
  font-size: 11pt !important;
  font-weight: 500;
  padding: 0.75rem !important;
}

.navbar-sshi {
  color: #fff !important;
  background-color: rgb(0 43 106) !important;
  height: 5em;
  family: "Inter", sans-serif;
}

.sshi-brand {
  height: 32px !important;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.navbar-light .navbar-nav .nav-link {
  color: #fff !important;
}

.navbar-light .navbar-nav .nav-link.active {
  background-color: #fff;
  color: #fff !important;
  border-bottom-left-radius: 0.75rem !important;
  border-bottom-right-radius: 0.75rem !important;
  border: none;
}
</style>
<template>
  <div>
    <b-navbar
      toggleable="lg"
      type="light"
      class="navbar-sshi fixed-top navbar-primary"
    >
      <b-container fluid style="margin-left: 7em; margin-right: 7em">
        <b-navbar-brand to="/sshi"
          ><b-img
            src="/img/sshi/sshi-white.png"
            fluid
            alt="SSHI"
            class="sshi-brand"
          ></b-img>
          <b-img
            src="/img/bps.svg"
            fluid
            alt="BPS-Statistics Indonesia"
            class="sshi-brand"
          ></b-img>
          <h5
            class="italic font-arial uppercase"
            data-asw-orgfontsize="20"
            style="
              font-style: italic;
              font-size: 25px;
              display: contents;
              color: white !important;
              font-family: Arial, sans-serif;
            "
          >
            BPS-Statistics Indonesia
          </h5>
        </b-navbar-brand>
        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item href="/sshi">Beranda</b-nav-item>
            <b-nav-item href="/sshi/tentang">Tentang</b-nav-item>
            <b-nav-item href="/sshi/news">Berita dan Kegiatan</b-nav-item>
            <b-nav-item href="/sshi/katalog-data">Katalog Data</b-nav-item>
            <b-nav-item href="/sshi/tabel-dinamis/v3">Tabel Dinamis</b-nav-item>
            <!--<b-nav-item-dropdown right>-->
            <!-- Using 'button-content' slot -->
            <!--<template #button-content>
                <em style="color: white">Bahasa</em>
              </template>
              <b-dropdown-item href="#">Indonesia</b-dropdown-item>
              <b-dropdown-item href="#">English</b-dropdown-item>
            </b-nav-item-dropdown>-->
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
    <b-sidebar id="sidebar-backdrop" title="Pengaturan" right backdrop shadow>
      <div class="px-3 py-2">
        <filter-data @get-data="getFilter" />
      </div>
    </b-sidebar>
  </div>
</template>
<script>
import filterData from "../../views/sshi/components/FilterData.vue";
export default {
  name: "navbar-sshi",
  data() {
    return {
      filter: [],
    };
  },
  components: {
    filterData,
  },
  created() {},
  methods: {
    getFilter(data) {
      this.filter = data;
    },
  },
};
</script>
